import { type FC, memo } from 'react';

import clsx from 'clsx';
import { useLocation, useNavigate } from 'react-router';

import { ROUTE_PATHS } from '@/shared/config/router/types';
import { useFeatureFlag } from '@/shared/hooks/use-feature-flag';

import s from './DevBanner.module.scss';

interface Props {
  className?: string;
}

const Component: FC<Props> = ({ className }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isKassir } = useFeatureFlag();

  const isDevPage = location.pathname === ROUTE_PATHS.DEV;

  return (
    <>
      {isKassir && !isDevPage && (
        <div
          className={clsx(s['go-to-dev'], className)}
          onClick={() => {
            navigate(`${ROUTE_PATHS.DEV}`);
          }}
        >
          {'DEV'}
        </div>
      )}
    </>
  );
};

export const DevBanner = memo(Component);
